// extracted by mini-css-extract-plugin
export default {"btnsWrapper":"OrderManageFromFooter_btnsWrapper__L+j8P","backButton":"OrderManageFromFooter_backButton__UF4Wz"};